'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getInputValuePrefix = getInputValuePrefix;
exports.removeInputValuePrefix = removeInputValuePrefix;

var _core = require('libphonenumber-js/core');

function getInputValuePrefix(country, international, metadata) {
	return country && international ? '+' + (0, _core.getCountryCallingCode)(country, metadata) : '';
}

function removeInputValuePrefix(value, prefix) {
	if (prefix) {
		value = value.slice(prefix.length);
		if (value[0] === ' ') {
			value = value.slice(1);
		}
	}
	return value;
}
//# sourceMappingURL=inputValuePrefix.js.map